<template>
  <section class="dp-layout parking-page parking-approval-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction"></toolbar>

      <div class="parking-stat-wrap">
        <div class="parking-stat-cards" :class="{ 'is-summary-loading': summaryLoading }">
          <div class="parking-stat-card stat-update clickable" :class="{ active: isQuick('Student', 'Pending') }" @click="quickFilter('Student', 'Pending')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-user"></i></span>
              <span class="stat-card-label">家长待班主任审</span>
            </div>
            <div class="stat-card-value">{{ summary.parentPendingCount }}</div>
          </div>
          <div class="parking-stat-card stat-exit clickable" :class="{ active: isQuick('Teacher', 'Pending') }" @click="quickFilter('Teacher', 'Pending')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-s-custom"></i></span>
              <span class="stat-card-label">教师待管理员审</span>
            </div>
            <div class="stat-card-value">{{ summary.teacherPendingCount }}</div>
          </div>
          <div class="parking-stat-card stat-synced clickable" :class="{ active: isQuick('', 'Approved') }" @click="quickFilter('', 'Approved')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-circle-check"></i></span>
              <span class="stat-card-label">已通过</span>
            </div>
            <div class="stat-card-value">{{ summary.approvedCount }}</div>
          </div>
          <div class="parking-stat-card stat-failed clickable" :class="{ active: isQuick('', 'Rejected') }" @click="quickFilter('', 'Rejected')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-circle-close"></i></span>
              <span class="stat-card-label">已驳回</span>
            </div>
            <div class="stat-card-value">{{ summary.rejectedCount }}</div>
          </div>
          <div class="parking-stat-card stat-total clickable" :class="{ active: isQuick('', '') }" @click="quickFilter('', '')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-s-data"></i></span>
              <span class="stat-card-label">申请总数</span>
            </div>
            <div class="stat-card-value">{{ summary.totalCount }}</div>
          </div>
        </div>
      </div>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">车牌申请<span class="count">共 {{ total }} 条</span></div>
          <span class="panel-tip">同一学生的多位监护人分别提交、分别审批；额度按学生合计校验</span>
        </div>

        <div class="tbl-scroll-host">
          <el-table :data="rows" v-loading="listLoading" class="custom-tbl" style="width:100%" height="100%">
            <el-table-column type="index" label="序号" width="60" :index="rowIndex"></el-table-column>
            <el-table-column label="类型" width="80">
              <template slot-scope="scope">
                <span :class="['subject-tag', scope.row.subjectType === 'Teacher' ? 'is-teacher' : 'is-parent']">
                  {{ scope.row.subjectType === 'Teacher' ? '教师' : '家长' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="车主" min-width="140">
              <template slot-scope="scope">
                <template v-if="scope.row.subjectType === 'Teacher'">{{ scope.row.teacherName || '-' }}</template>
                <template v-else>
                  {{ scope.row.parentName || '-' }}
                  <span class="sub-text">学生：{{ scope.row.studentName || '-' }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="提交人" width="120">
              <template slot-scope="scope">
                {{ scope.row.applicantName || '-' }}
                <span class="sub-text">{{ applicantRoleText(scope.row.applicantRole) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请后车牌" min-width="260">
              <template slot-scope="scope">
                <div v-if="scope.row.vehicles.length" class="plate-list">
                  <span v-for="item in scope.row.vehicles" :key="item.plateNo" class="plate-no-badge">{{ item.plateNo }}</span>
                </div>
                <span v-else class="text-muted">清空全部车牌</span>
              </template>
            </el-table-column>
            <el-table-column label="本次变化" min-width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.addedPlates.length || scope.row.removedPlates.length" class="plate-change">
                  <div v-if="scope.row.addedPlates.length" class="plate-change__line plate-change__line--add">
                    新增：{{ scope.row.addedPlates.join('、') }}
                  </div>
                  <div v-if="scope.row.removedPlates.length" class="plate-change__line plate-change__line--remove">
                    删除：{{ scope.row.removedPlates.join('、') }}
                  </div>
                </div>
                <span v-else class="text-muted">仅调整车辆类型</span>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" width="150">
              <template slot-scope="scope"><span class="time-text">{{ formatDateTime(scope.row.createTime) }}</span></template>
            </el-table-column>
            <el-table-column label="状态" width="90">
              <template slot-scope="scope">
                <el-tag :type="statusOf(scope.row.status).type" size="small">{{ statusOf(scope.row.status).label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审批信息" min-width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.status !== 'Pending'">
                  {{ scope.row.approverName || '-' }}
                  <span class="sub-text">{{ formatDateTime(scope.row.approveTime) }}</span>
                  <span v-if="scope.row.rejectReason" class="sub-text">原因：{{ scope.row.rejectReason }}</span>
                </template>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="can('auditParent') || can('auditTeacher')" label="操作" width="160" fixed="right" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 'Pending' && canAudit(scope.row)" class="table-op-pair">
                  <el-button type="text" class="table-op-link" @click="audit(scope.row, true)">通过</el-button>
                  <el-button type="text" class="table-op-link table-op-link--danger" @click="audit(scope.row, false)">驳回</el-button>
                </div>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float:right"
          ></el-pagination>
        </el-col>
      </div>
    </section>
  </section>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import {
  getParkingPlateRequestPage,
  getParkingPlateRequestSummary,
  auditParkingParentPlate,
  auditParkingTeacherPlate
} from '@/api/parking'
import { toCamel, readPage, formatDateTime, plateStatusMap, loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true }
]

export default {
  name: 'ParkingPlateApproval',
  components: { Toolbar },
  data() {
    return {
      schoolId: null,
      listLoading: false,
      summaryLoading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      keyword: '',
      subjectType: '',
      status: 'Pending',
      summary: { parentPendingCount: 0, teacherPendingCount: 0, approvedCount: 0, rejectedCount: 0, totalCount: 0 },
      buttonFuncs: [],
      buttonList: [],
      searchList: [
        { key: 'keyword', label: '关键字', placeholder: '学生/教师/提交人', width: '170px' },
        {
          key: 'subjectType', label: '类型', type: 'select', clearable: true, initValue: '', width: '110px',
          options: [
            { value: '', label: '全部' },
            { value: 'Student', label: '家长' },
            { value: 'Teacher', label: '教师' }
          ]
        },
        {
          key: 'status', label: '状态', type: 'select', clearable: true, initValue: 'Pending', width: '110px',
          options: [
            { value: '', label: '全部' },
            { value: 'Pending', label: '待审批' },
            { value: 'Approved', label: '已通过' },
            { value: 'Rejected', label: '已驳回' },
            { value: 'Cancelled', label: '已撤销' }
          ]
        }
      ]
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      immediate: true,
      handler(value) {
        this.schoolId = value
        this.page = 1
        if (value) this.loadData()
      }
    }
  },
  created() {
    this.buttonFuncs = loadButtonFuncs(this.$route.path)
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, this.buttonFuncs)
  },
  methods: {
    formatDateTime,
    /** 当前角色是否分配了该按钮权限 */
    can(func) {
      return this.buttonFuncs.includes(func)
    },
    /** 家长申请需 auditParent，教师申请需 auditTeacher */
    canAudit(row) {
      return this.can(row.subjectType === 'Teacher' ? 'auditTeacher' : 'auditParent')
    },
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') this[item.Func](item)
    },
    statusOf(status) {
      return plateStatusMap[status] || { label: status || '-', type: 'info' }
    },
    applicantRoleText(role) {
      return { Parent: '家长', ClassTeacher: '班主任代录', TeacherSelf: '教师本人' }[role] || ''
    },
    rowIndex(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    isQuick(subjectType, status) {
      return this.subjectType === subjectType && this.status === status
    },
    quickFilter(subjectType, status) {
      if (this.isQuick(subjectType, status)) return
      this.subjectType = subjectType
      this.status = status
      this.page = 1
      const toolbar = this.$refs.toolbar
      if (toolbar && toolbar.searchObj) {
        this.$set(toolbar.searchObj, 'subjectType', subjectType)
        this.$set(toolbar.searchObj, 'status', status)
      }
      this.loadList()
    },
    handleSearchBtn(item) {
      const s = (item && item.search) || {}
      this.keyword = s.keyword || ''
      this.subjectType = s.subjectType || ''
      this.status = s.status || ''
      this.page = 1
      this.loadData()
    },
    loadData() {
      if (!this.schoolId) return
      this.loadSummary()
      this.loadList()
    },
    async loadSummary() {
      this.summaryLoading = true
      try {
        const res = await getParkingPlateRequestSummary(this.schoolId)
        if (res.data && res.data.success) {
          this.summary = { ...this.summary, ...toCamel(res.data.response || {}) }
        }
      } catch (e) {
        // 汇总失败不阻断列表
      } finally {
        this.summaryLoading = false
      }
    },
    async loadList() {
      if (!this.schoolId) return
      this.listLoading = true
      try {
        const res = await getParkingPlateRequestPage({
          schoolId: this.schoolId,
          subjectType: this.subjectType,
          status: this.status,
          keyword: this.keyword,
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data && res.data.success) {
          const { list, total } = readPage(res)
          this.rows = list.map(x => ({
            ...x,
            vehicles: x.vehicles || [],
            addedPlates: x.addedPlates || [],
            removedPlates: x.removedPlates || []
          }))
          this.total = total
        } else {
          this.$message.error((res.data && res.data.msg) || '申请列表加载失败')
        }
      } catch (e) {
        this.$message.error('申请列表加载失败')
      } finally {
        this.listLoading = false
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.loadList()
    },
    /** 审批通过或驳回（驳回需填写原因） */
    async audit(row, approved) {
      let rejectReason = ''
      const owner = row.subjectType === 'Teacher' ? row.teacherName : `${row.studentName} / ${row.parentName}`
      try {
        if (approved) {
          await this.$confirm(`确定通过「${owner}」的车牌申请吗？通过后立即生效并同步到车场系统。`, '审批通过', { type: 'info' })
        } else {
          const result = await this.$prompt(`驳回「${owner}」的车牌申请`, '驳回申请', {
            inputPlaceholder: '请输入驳回原因',
            inputValidator: v => !!(v && v.trim()) || '请输入驳回原因'
          })
          rejectReason = result.value.trim()
        }
      } catch (e) {
        return
      }
      const payload = { schoolId: this.schoolId, requestId: row.requestId, approved, rejectReason }
      const res = row.subjectType === 'Teacher'
        ? await auditParkingTeacherPlate(payload)
        : await auditParkingParentPlate(payload)
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || (approved ? '已通过' : '已驳回'))
        this.loadData()
      } else {
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    }
  }
}
</script>

<style>
@import './parking-page.css';
</style>
